import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PinGate from "@/components/PinGate";

export default function ProtectedRoute({ children }) {
  const { user, ready, pinRequired } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
        <div className="h-8 w-8 rounded-full border-2 border-sky-500 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) {
    if (pinRequired) return <PinGate />;
    return <Navigate to="/login" replace />;
  }
  return children;
}
